module.exports = __webpack_public_path__ + "img/nav.86d0e82e.png";